// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"app-module__logoContainer___1cwcY","logo":"app-module__logo___3f4_N"};